import Vue from 'vue'

export const timestamp_2_date = timestamp =>
  new Intl.DateTimeFormat('en-GB', { dateStyle: 'full', timeStyle: 'long' }).format(new Date(timestamp))

Vue.filter('timestamp_2_date', timestamp_2_date)
